import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CommonDropdownControlDirective } from 'app/shared/directives/control/common-dropdown-control.directive';

@Component({
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BreadcrumbsDropdownComponent)
    }
  ],
  selector: 'kh-breadcrumbs-dropdown',
  styleUrls: ['./breadcrumbs-dropdown.component.less'],
  templateUrl: './breadcrumbs-dropdown.component.html',
  standalone: false
})
export class BreadcrumbsDropdownComponent<TItem, TValue> extends CommonDropdownControlDirective<TItem, TValue> {
  @Input() public arrowColor = 'arrow-blue';
  @Input() public triggerLabel?: string;
  @Input() public isActive = false;

  public get resolvedTriggerLabel(): string | null {
    const selectedLabel = this.resolveName(this.selectedItem);

    if (!this.triggerLabel) {
      return selectedLabel || null;
    }

    return selectedLabel ? `${this.triggerLabel}: ${selectedLabel}` : this.triggerLabel;
  }
}
